import React, { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { Palette, FloppyDisk } from '@phosphor-icons/react';

export default function Appearance() {
  const [theme, setTheme] = useState('light');
  const [fontSize, setFontSize] = useState('medium');

  useEffect(() => {
    const savedTheme = localStorage.getItem('dws_theme') || 'light';
    const savedFontSize = localStorage.getItem('dws_font_size') || 'medium';
    setTheme(savedTheme);
    setFontSize(savedFontSize);
  }, []);

  const handleSave = () => {
    localStorage.setItem('dws_theme', theme);
    localStorage.setItem('dws_font_size', fontSize);
    
    // Apply changes to document root
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    document.documentElement.style.fontSize = 
      fontSize === 'small' ? '14px' : fontSize === 'large' ? '18px' : '16px';

    toast.success('Appearance settings saved successfully!');
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm">
      <div className="flex items-center gap-3 mb-6 border-b pb-3">
        <Palette size={28} className="text-orange-500" />
        <div>
          <h2 className="text-xl font-bold text-gray-800">Appearance</h2>
          <p className="text-sm text-gray-500">Customize the visual theme, colors, and text size</p>
        </div>
      </div>

      <div className="space-y-6 max-w-md">
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">Theme Mode</label>
          <div className="flex gap-4">
            {['light', 'dark'].map(t => (
              <label key={t} className="flex items-center gap-2 capitalize font-medium text-gray-700">
                <input
                  type="radio"
                  name="theme"
                  value={t}
                  checked={theme === t}
                  onChange={() => setTheme(t)}
                  className="w-4 h-4 text-green-600 focus:ring-green-500"
                />
                {t} Mode
              </label>
            ))}
          </div>
        </div>

        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">Font Size</label>
          <div className="flex gap-4">
            {['small', 'medium', 'large'].map(sz => (
              <label key={sz} className="flex items-center gap-2 capitalize font-medium text-gray-700">
                <input
                  type="radio"
                  name="fontSize"
                  value={sz}
                  checked={fontSize === sz}
                  onChange={() => setFontSize(sz)}
                  className="w-4 h-4 text-green-600 focus:ring-green-500"
                />
                {sz}
              </label>
            ))}
          </div>
        </div>

        <button
          onClick={handleSave}
          className="bg-green-500 hover:bg-green-600 text-white px-6 py-2.5 rounded-lg font-semibold flex items-center gap-2 shadow-sm"
        >
          <FloppyDisk size={20} /> Save Appearance
        </button>
      </div>
    </div>
  );
}
